import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import { FC, ReactNode, useCallback, useEffect } from 'react';
import { Axios } from '../../services/_axios';
import { clearLocalStorageItems } from '../../utils/helper-functions/user';
import { StyledCircularProgress } from '../../containers/layout.styles';

const AuthTokenWrapper: FC<{ children: ReactNode }> = ({ children }) => {
  const { getAccessTokenSilently, logout } = useAuth0();
  const getToken = useCallback(async () => {
    try {
      const getAccessToken = async () => {
        const token = await getAccessTokenSilently({
          audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        });
        Axios.token = token;
        return token;
      };
      Axios.getAccessToken = getAccessToken;
      await getAccessToken();
    } catch (error) {
      clearLocalStorageItems();
      logout();
    }
  }, [getAccessTokenSilently, logout]);

  useEffect(() => {
    getToken();
  }, [getToken]);
  return children;
};

export default withAuthenticationRequired(AuthTokenWrapper, {
  onRedirecting: () => <StyledCircularProgress className='loader' />,
});
